import * as _ from 'lodash'
import React from 'react';
import * as actions from '../actions';
import util from '../util';
import componentServices from '../componentServices';

import { sortableComponent } from './sharedComponents';

const ContactTable = sortableComponent(({ updateSort, sortKey, list, ...childProps }) => {
	return (
		<table className="sortable interactive" cellPadding="0" cellSpacing="0">
			<ContactTableHeader updateSort={updateSort} sortKey={sortKey} {...childProps} />
			<ContactTableBody contacts={list} {...childProps} />
		</table>
	);
});

class ContactTableHeader extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}
	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}
	render () {
		return (
			<thead>
				<tr>
					<td />
					<td className={this.getClassName('lastName')} onClick={this.handleClick.bind(this, 'lastName')}>Last</td>
					<td className={this.getClassName('firstName')} onClick={this.handleClick.bind(this, 'firstName')}>First</td>
					<td className={this.getClassName('emailAddress')} onClick={this.handleClick.bind(this, 'emailAddress')}>Email</td>
					<td className={this.getClassName('workPhoneNumber')} onClick={this.handleClick.bind(this, 'workPhoneNumber')}>Office</td>
					<td className={this.getClassName('mobilePhoneNumber')} onClick={this.handleClick.bind(this, 'mobilePhoneNumber')}>Mobile</td>
					<td className={this.getClassName('title')} onClick={this.handleClick.bind(this, 'title')}>Job Title</td>
					<td />
				</tr>
			</thead>
		);
	}
}

const ContactTableBody = ({ contacts, ...childProps }) => {
	const rows:JSX.Element[] = [];
	if (contacts) {
		contacts.forEach(contact => {
			rows.push(<ContactTableRow contact={ contact } key={contact.key} {...childProps} />);
		});
	}
	return (<tbody>{rows}</tbody>);
};

class ContactTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick () {
		const { contact } = this.props;

		componentServices.router.pushHistory(componentServices.router.pushPathSegment(contact.key));
	}
	render () {
		const { contact } = this.props;

		return (
			<tr onClick={ this.handleClick} >
				<td />
				<td>{ contact.lastName }</td>
				<td>{ contact.firstName }</td>
				<td>{ contact.emailAddress }</td>
				<td className="nowrap">{ contact.workPhoneNumber }</td>
				<td className="nowrap">{ contact.mobilePhoneNumber }</td>
				<td>{ contact.title }</td>
				<td />
			</tr>
		);
	}
}

export default class ContactList extends React.Component<any,any> {
	componentDidMount () {
		actions.stashHeaderActions();
		actions.setHeaderAction({
			key: 'contact-add-action',
			element: <button className="icon addPerson" onClick={this.handleAddContactClick.bind(this)}><span /></button>
		});
	}
	componentWillUnmount () {
		actions.deleteHeaderAction({ key: 'contact-add-action' });
		actions.unstashHeaderActions();
	}
	handleAddContactClick (e) {
		e.preventDefault();

		componentServices.router.pushHistory(componentServices.router.pushPathSegment(util.generateGuid()));
	}
	render () {
		const { contractor } = this.props;
		const list = _.filter(contractor ? contractor.contacts : [], c => !c.externalFormKey);

		return <section><ContactTable list={ list } initialSortKey="fullName" /></section>;
	}
}
